export enum EasternTownshipType {
    Burough = 1,
    CivilDistrict,
    Municipality,
    TaxDistrict,
    Town,
    Township,
    Village,
    None,
}

export const EasternTownshipTypeArray = () => {
    return [
        { id: 1, name: 'Borough' },
        { id: 2, name: 'Civil District' },
        { id: 3, name: 'Municipality' },
        { id: 4, name: 'Tax District' },
        { id: 5, name: 'Town' },
        { id: 6, name: 'Township' },
        { id: 7, name: 'Village' },
        { id: 8, name: 'None' },
    ];
};



// WEBPACK FOOTER //
// ./src/models/EasternTownshipType.ts